import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import Script from 'next/script';
import { MinApp } from '../../../components/MinApp'
import { PageContext }from '../../../contexts/pageContext'
import { getConfig } from '../../../contexts/configs/index'
import { ProductCollection } from '../../../components/ProductCollections';


function Chat({}) {

  const API_URL = process.env.NEXT_PUBLIC_API_URL;

  const router = useRouter();
  const slug = router.query.slug; // access userid from route parameters
  const [threadData, setThreadData] = useState(null);

  interface ThreadData {
    status: string;
    data: {
      storeId: string;
      topic: string;
      products: any[];
      chats: any[]; // replace any with the appropriate type if you know it

    };
  }


  useEffect(() => {
    console.log("useEffect")
    fetchData(); // Call your fetch function here
  }, [slug]); // The empty dependency array ensures this effect runs only once, on component mount

  async function fetchData() {
      console.log("data")
    try {
      const response = await fetch(`/api/telemetry/slug?slug=${slug}`);
      const data: ThreadData = await response.json()
      console.log("data", data);
      setThreadData(data);
      console.log(data); // Do something with the fetched data
    } catch (error) {
      console.log('Error:', error);
    }
  };

  return (
    <>
    <Head>
        <title> Claros - {threadData?.data?.object ? threadData.data.object : "Thread"}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:url" content={`https://www.claros.so/chats/${slug}`}/>
        <meta property="og:title" content={`Claros ${threadData?.data?.object ? "- " + threadData.data.object  : ""}`} />
        <meta property="og:description" content={`${threadData?.data?.topic ? threadData.data.topic + " Picked By AI" : "Find better products, faster"}`}/>
        <meta property="og:type" content="website" />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content={`Claros ${threadData?.data?.object ?  "- " + threadData.data.object : ""}`} />
        <meta property="twitter:description" content={`${threadData?.data?.topic ? threadData.data.topic + " Picked By AI" : "Find better products, faster"}`} />

        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="generator" content="Framer 937e5b9" />
        <meta name="description" content={`${threadData?.data?.topic ? threadData.data.topic + " Picked By AI" : "Find better products, faster"}`} />
    </Head>


    {threadData && threadData.status == "success"
      ? <PageContext.Provider value={getConfig(threadData.data.storeId)}>
          {threadData.data.product_collection
            ? <ProductCollection
                threadId={threadData.data.sessionId}
                topic={threadData.data.topic}
                products={threadData.data.chats[threadData.data.chats.length - 1].recs}
                askedQuestions={threadData.data.chats[threadData.data.chats.length - 1].askedQuestions}
              />
            : <MinApp
                threadId={threadData.data.sessionId}
                topic={threadData.data.topic}
                topicSelected={true}
                passedProducts={threadData.data.chats[threadData.data.chats.length - 1].recs}
                chats={threadData.data.chats}
                products={threadData.data.products}
                config={getConfig(threadData.data.storeId)}
                className="bg-bgwhite"/>
          }
        </PageContext.Provider>
        : null
    }
    </>
  )
}
export default Chat;
